import { gql } from "@apollo/client";

export const AddCompany = gql`
  mutation AddCompany(
    $token: String!
    $input: CreateAtsCompanyInput!
    $customer_id: ID!
    $user_details: SubscribedUser!
  ) {
    AddCompany(
      token: $token
      input: $input
      customer_id: $customer_id
      user_details: $user_details
    )
  }
`;

export const UpdateCompany = gql`
  mutation UpdateCompany(
    $token: String!
    $ats_company_id: ID!
    $user_details: SubscribedUser!
    $input: UpdateAtsCompanyInput!
  ) {
    UpdateCompany(
      token: $token
      ats_company_id: $ats_company_id
      user_details: $user_details
      input: $input
    )
  }
`;

export const DeleteCompany = gql`
  mutation DeleteCompany(
    $token: String!
    $ats_company_id: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteCompany(
      token: $token
      ats_company_id: $ats_company_id
      user_details: $user_details
    )
  }
`;
